export const ABOUT_COPY = "Behind the Scenes";
